<template>
    <div id="video-block">
        <v-card dark class="mb-2 mr-2 black-box">
            <v-card-title><span class="video-heading">{{vid.name}}</span></v-card-title>

            <a data-fancybox="vid" data-type="iframe" :href="`https://www.youtube.com/embed/${vid.url}`">
                <div>
                    <img :src="`/img/videos/${vid.pic}`" :alt="vid.name" width="100%"> 
                </div>
            </a>                                                             
        </v-card>
    </div>
</template>

<script>
    export default {
        props: ['vid']
    }
</script>


<style>
    .black-box {
        background-color: #111!important;
    }
</style>